import { render, staticRenderFns } from "./fragment-button.vue?vue&type=template&id=4447969f&scoped=true&"
import script from "./fragment-button.vue?vue&type=script&lang=js&"
export * from "./fragment-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4447969f",
  null
  
)

export default component.exports